import { helpers } from 'vuelidate/lib/validators'
export default date =>
  helpers.withParams(
    { type: 'minDate', min: date },
    function(value, parentVm) {
      if (!date) {
        return true
      }
      return !helpers.req(value) || value >= date
    }
  )